import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { bonuses } from '../data/bonuses';
import { priceToday } from '../data/offer';
export function BonusSection() {
  return <section className="py-24 px-4 bg-black" data-id="element-16" data-mp="22dityjcuzf3y">
      <div className="max-w-5xl mx-auto" data-id="element-17" data-mp="1ydrwjwstu0qg">
        <div className="text-center mb-16" data-id="element-18" data-mp="1yet6tz20qj74">
          <p className="text-gold font-bold tracking-widest uppercase mb-2" data-id="element-19" data-mp="1anxkvik8ui7s">
            Tout inclus dans les {priceToday} — rien de séparé, rien de caché
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold" data-id="element-20" data-mp="15njavuz30y74">🎁 Les 5 Bonus — Inclus dans ton pack</h2>
        </div>
        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-21" data-mp="1eqapu4r62c3i">
          {bonuses.map((bonus, index) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index % 2 * 0.1
        }} className="bg-dark-card border border-gold/20 rounded-2xl p-8 relative hover:border-gold/50 transition-colors" data-id="element-22" data-mp="qzy9c5huv71b" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-gold/10 text-gold px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm border-b border-l border-gold/20" data-id="element-23" data-mp="2jhway6pb9ob7">
                BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center text-gold mb-6" data-id="element-24" data-mp="1qtquhw5ailh6">
                <Gift size={24} data-id="element-25" data-mp="1vtd31sa6bdjn" />
              </div>
              <h3 className="text-xl font-serif font-bold mb-4 pr-20" data-id="element-26" data-mp="1vu4y91zuz99e">{bonus.title}</h3>
              <p className="text-gray-300 text-sm mb-6 leading-relaxed" data-id="element-27" data-mp="20tho7vm10wg7">{bonus.desc}</p>
              <p className="text-gold-light text-sm italic font-medium" data-id="element-28" data-mp="25rsxo58et4xw">{bonus.benefit}</p>
            </motion.div>)}
        </div>
        <CountdownTimer data-id="element-29" data-mp="3h5el9lymeyhb" />
      </div>
    </section>;
}